import { IBaseMigrationStaffer } from '../../../interfaces';
import { StaffToUserMappingHandler } from '../../../mappings/staff-to-user';
import {
  PracticeWorksStaffer,
  IPracticeWorksStaffer,
  StafferSourceEntity,
} from '../../source/entities/staff';

export class PracticeWorkStaffToUserMappingHandler extends StaffToUserMappingHandler<
  PracticeWorksStaffer,
  StafferSourceEntity
> {
  override sourceEntity = new StafferSourceEntity();
  translateFn = (record: IPracticeWorksStaffer): IBaseMigrationStaffer => ({
    id: record.id,
    name: `${record.firstName} ${record.surname}`,
    providerNo: '',
  });
}
